<template>
  <div class="component">
    <div class="tab_information">
      <div class="square" v-if="componentData.personinfo && componentData.personinfo.length || componentData.marital && componentData.marital.length"></div>
      <div class="info-content">
        <div class="info-content-item" v-if="componentData.personinfo && componentData.personinfo.length">
          <div class="info-content-item-title">基本信息</div>
          <portrait-labels :labelList="componentData.personinfo"></portrait-labels>
        </div>
        <div class="info-content-item"  v-if="componentData.marital && componentData.marital.length">
          <div class="info-content-item-title">婚育状况</div>
          <portrait-labels :labelList="componentData.marital"></portrait-labels>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "TabInformation",
  props: {
    componentData: [Object, Array],
    cusParam_imgUrl: String,
  },
  data() {
    return {
    }
  },
  mounted() {
    console.log(this.componentData)
    console.log("cusParam_imgUrl:" + this.cusParam_imgUrl)
  },
  methods: {
  },
}
</script>

<style lang="less">
.tab_information {
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  margin-left: -20px;

  .square {
    width: 6px;
    height: 16px;
    background: var(--theme-color);
    margin-right: 14px;
    margin-top:2px
  }
  .info-content {
    flex-grow: 1;
    flex-shrink: 1;
    font-size: 14px;
    color: #212121;
    .info-content-item{
      display: flex;
      flex-direction: row;
      .info-content-item-title{
        font-size: 14px;
        font-weight: 600;
        margin-right: 12px;
        flex-shrink: 0;

      }

    }
  }
}
</style>

